import React from "react";
import { Link } from "react-router-dom";
import "./activeLink.scss";

interface ActiveLinkProps {
  targetLink: string;
}
const ActiveLink: React.FC<ActiveLinkProps> = ({ targetLink }) => {
  return (
    <div className="active__link">
      <Link to="/assessment">Question Set List</Link>
      <p style={{ fontSize: "10px" }}>&#10095;</p>
      <p> {targetLink}</p>
    </div>
  );
};

export default ActiveLink;
